import { Truck, ShieldCheck, RefreshCw, Sparkles } from "lucide-react";

/**
 * SRC-styled scrolling marquee that sits above the fixed Header on every
 * ecommerce page. Messages come from the template config so different
 * store types can advertise the right value props (e.g. "SUBSCRIBE & SAVE 20%"
 * for skincare vs "FREE SHIPPING OVER $100" for streetwear).
 *
 * `DEFAULT_MESSAGES` is exported (Iter 71B) as the CANONICAL fallback
 * for both the runtime render below AND the Announcement Messages
 * editor in the Visual Editor — so we never fork the default content
 * into a second hardcoded copy. Icons are STORED as string keys
 * (`"truck"`, `"refresh"`, …) and resolved to Lucide components only
 * inside the render step, which lets deep-cloning tools like
 * `structuredClone` work on the constant.
 */
export const DEFAULT_MESSAGES = [
  { icon: "truck",    text: "FREE SHIPPING ON ORDERS OVER $100" },
  { icon: "refresh",  text: "30-DAY FREE RETURNS — NO QUESTIONS" },
  { icon: "shield",   text: "SECURE GUEST CHECKOUT" },
  { icon: "sparkles", text: "NEW DROP IN STOCK NOW" },
];

const ICONS = { truck: Truck, shield: ShieldCheck, refresh: RefreshCw, sparkles: Sparkles };

export default function AnnouncementBar({ messages }) {
  const rows = (messages && messages.length ? messages : DEFAULT_MESSAGES).map((m) => ({
    ...m,
    icon: typeof m.icon === "string" ? (ICONS[m.icon] || Sparkles) : m.icon,
  }));
  const loop = [...rows, ...rows, ...rows, ...rows];
  return (
    <div
      data-testid="announcement-bar"
      className="bg-black text-white text-[11px] font-medium py-2 overflow-hidden border-b border-black"
    >
      <div className="marquee-track">
        {loop.map((m, i) => {
          const Icon = m.icon;
          return (
            <span key={i} className="inline-flex items-center gap-2 px-8 tracking-[0.18em] uppercase">
              <Icon className="w-3.5 h-3.5" strokeWidth={1.5} />
              {m.text}
            </span>
          );
        })}
      </div>
    </div>
  );
}
